// app/core/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { map, catchError, of } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
  const session = inject(SessionService);
  const userService = inject(UserService);
  const router = inject(Router);

  const token = session.currentToken;

  if (!token) {
    return router.createUrlTree(['/signin']);
  }

  const checkAdmin = () => {
    const user = userService.currentUser;

    if (user && user.userType === "admin") {
      return true;
    }

    return router.createUrlTree(['/signin']);
  };

  // Si le user est déjà chargé → on vérifie directement
  if (userService.currentUser) {
    return checkAdmin();
  }

  // Sinon → on charge le profil puis on vérifie
  return userService.loadProfile().pipe(
    map(() => checkAdmin()),
    catchError(() => of(router.createUrlTree(['/signin'])))
  );
};
